import { render, staticRenderFns } from "./minorRepair.vue?vue&type=template&id=bb7f56bc&scoped=true&"
import script from "./minorRepair.vue?vue&type=script&lang=js&"
export * from "./minorRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7f56bc",
  null
  
)

export default component.exports